"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var multiCurrencyPriceStyles = styles_1.makeStyles(function (_a) {
    var typography = _a.typography;
    return ({
        priceElement: {
            fontFamily: typography.fontFamily2,
        },
        divider: {
            margin: '0 5px',
            fontFamily: typography.fontFamily2,
        },
    });
}, { name: 'Summary_MultiCurrencyPrice' });
exports.default = multiCurrencyPriceStyles;
